// extracted by mini-css-extract-plugin
export var button__primary = "styles-module--button__primary--30d46";
export var container = "styles-module--container--949aa";
export var containerOpen = "styles-module--container-open--62e0d";
export var cursor = "styles-module--cursor--ef4f3";
export var cursorFollower = "styles-module--cursor-follower--88b77";
export var headingCentered = "styles-module--heading-centered--f08a1";
export var hidden = "styles-module--hidden--0c1e6";
export var navList = "styles-module--nav-list--a13a1";
export var navListItem = "styles-module--nav-list-item--c7b81";
export var noScroll = "styles-module--no-scroll--0db77";
export var open = "styles-module--open--d3a5b";
export var pageTemplatePageGame = "styles-module--page-template-page-game--7c76b";
export var section__wrapper = "styles-module--section__wrapper--f122d";
export var section__wrapperLarge = "styles-module--section__wrapper--large--a8371";
export var toggle = "styles-module--toggle--458f0";